<template>
  <v-card class="elevation-0" style="width: 400px;">
    <v-tabs v-model="tabs" centered slider-color="yellow">
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#g-chung" class="primary--text">
        <v-badge color="red" overlap>
          <span v-if="top5Notifications" slot="badge">{{top5Notifications.global_total || 0}}</span>
          <v-icon>fa-info</v-icon>
        </v-badge>
      </v-tab>

      <v-tab href="#g-congkhai" class="primary--text">
        <v-badge color="red" overlap>
          <span v-if="top5Notifications" slot="badge">{{top5Notifications.public_total || 0}}</span>
          <v-icon>fa-globe</v-icon>
        </v-badge>
      </v-tab>

      <v-tab href="#g-noibo" class="primary--text">
        <v-badge color="red" overlap>
          <span v-if="top5Notifications" slot="badge">{{top5Notifications.private_total || 0}}</span>
          <v-icon>fa-lock</v-icon>
        </v-badge>
      </v-tab>
    </v-tabs>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-list two-line class="pa-0">
        <v-tabs-items v-model="tabs">
          <v-tab-item value="g-chung">
            <v-card flat>
              <template v-if="!top5Notifications || top5Notifications.global_items.length == 0">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Bạn không có thông báo nào!</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-else v-for="item in top5Notifications.global_items">
                <v-list-item avatar :key="item.ID" @click="handleClick(item)">
                  <v-list-item-avatar>
                    <img :src="senderRole(item.SenderID, item.SenderUsername) | comment_avatar" alt="">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="senderName(item.SenderID, item.SenderUsername)"></v-list-item-title>
                    <v-list-item-subtitle v-bind:class="{ 'font-weight-bold': item.Status != 1 }"
                      v-html="item.Message"></v-list-item-subtitle>
                    <v-list-item-subtitle>{{ item.CreatedDate | display_date }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-divider></v-divider>
              <v-layout row pa-2>
                <v-flex lg6><v-btn block text class="ma-0" color="red" @click="readAll({'NotiType': 0, 'ID': '999999999999'})">Đọc tất cả</v-btn></v-flex>
                <v-flex lg6><v-btn block text class="ma-0" @click="displayAll(0)">Xem thêm</v-btn></v-flex>
              </v-layout>
              <v-divider></v-divider>
            </v-card>
          </v-tab-item>
          <v-tab-item value="g-congkhai">
            <v-card flat>
              <template v-if="!top5Notifications || top5Notifications.public_items.length == 0">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Bạn không có thông báo nào!</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-else v-for="item in top5Notifications.public_items">
                <v-list-item avatar :key="item.ID" @click="handleClick(item)">
                  <v-list-item-avatar>
                    <img :src="senderRole(item.SenderID, item.SenderUsername) | comment_avatar" alt="">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="senderName(item.SenderID, item.SenderUsername)"></v-list-item-title>
                    <v-list-item-subtitle v-bind:class="{ 'font-weight-bold': item.Status != 1 }"
                      v-html="item.Message"></v-list-item-subtitle>
                    <v-list-item-subtitle>{{ item.CreatedDate | display_date }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-divider></v-divider>
              <v-layout row pa-2>
                <v-flex lg6><v-btn block text class="ma-0" color="red" @click="readAll({'NotiType': 1, 'ID': '999999999999'})">Đọc tất cả</v-btn></v-flex>
                <v-flex lg6><v-btn block text class="ma-0" @click="displayAll(1)">Xem thêm</v-btn></v-flex>
              </v-layout>
              <v-divider></v-divider>
            </v-card>
          </v-tab-item>
          <v-tab-item value="g-noibo">
            <v-card flat>
              <template v-if="!top5Notifications || top5Notifications.private_items.length == 0">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Bạn không có thông báo nào!</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-else v-for="item in top5Notifications.private_items">
                <v-list-item avatar :key="item.ID" @click="handleClick(item)">
                  <v-list-item-avatar>
                    <img :src="senderRole(item.SenderID, item.SenderUsername) | comment_avatar" alt="">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="senderName(item.SenderID, item.SenderUsername)"></v-list-item-title>
                    <v-list-item-subtitle v-bind:class="{ 'font-weight-bold': item.Status != 1 }"
                      v-html="item.Message"></v-list-item-subtitle>
                    <v-list-item-subtitle>{{ item.CreatedDate | display_date }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-divider></v-divider>
              <v-layout row pa-2>
                <v-flex lg6><v-btn block text class="ma-0" color="red" @click="readAll({'NotiType': 2, 'ID': '999999999999'})">Đọc tất cả</v-btn></v-flex>
                <v-flex lg6><v-btn block text class="ma-0" @click="displayAll(2)">Xem thêm</v-btn></v-flex>
              </v-layout>
              <v-divider></v-divider>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { comment_avatar } from "@/commons/hpod";
import { display_date } from "@/commons/formater";
import { mapState } from "vuex";
export default {
  filters: { comment_avatar, display_date },
  data() {
    return {
      tabs: 'g-chung'
    }
  },
  computed: {
    ...mapState({
      staffs: state => state.commons.all_users,
      top5Notifications: state => state.notification.top5.data
    }),
  },
  methods: {
    handleClick(item) {
      // Yeu Cau Giao Hang: 0, Mua hộ: 1, Ký gửi: 2, Khiếu nại: 4, TTH: 5, Uỷ quyền: 6, Tài chính nội bộ: 7, Cơ hội: 8, Đối soát bao hàng: 9, Liên hệ: 10
      this.$store.dispatch("notification/setDetail", {
        'data': { 'ID': item.ID, 'Status': 1 },
        'id': item.ID
      });
      item.Status = 1;
      let routeData = null;
      if (item.OrderType === 0) {
        routeData = this.$router.resolve({
          name: "PaymentRequestDetail",
          params: {
            Pid: item.OrderID,
            title: `Chi tiết yêu cầu giao (#${item.OrderID})`
          },
          query: {
            'noti_type': item.NotiType
          }
        });
      }
      else if (item.OrderType == 1) {
        routeData = this.$router.resolve({
          name: "OrderDetail",
          params: {
            Pid: item.OrderID,
            title: `Chi tiết đơn hàng (#${item.OrderID})`
          },
          query: {
            'noti_type': item.NotiType
          }
        });
      } else if (item.OrderType == 2) {
        routeData = this.$router.resolve({
          name: "DepositDetail",
          params: {
            Pid: item.OrderID,
            title: `Chi tiết ký gửi (#${item.OrderID})`
          },
          query: {
            'noti_type': item.NotiType
          }
        });
      } else if (item.OrderType == 3) {
        routeData = this.$router.resolve({
          name: "WithdrawHistory"
        });
      } else if (item.OrderType == 4) {
        routeData = this.$router.resolve({
          name: "ComplainDetail",
          params: {
            Pid: item.OrderID,
            title: `Chi tiết khiếu nại (#${item.OrderID})`
          },
          query: {
            'noti_type': item.NotiType
          }
        });
      } else if (item.OrderType == 5) {
        routeData = this.$router.resolve({
          name: "PayServiceDetail",
          params: {
            Pid: item.OrderID,
            title: `Thanh toán trực tiếp (#${item.OrderID})`
          },
          query: {
            'noti_type': item.NotiType
          }
        });
      } else if (item.OrderType == 6) {
        routeData = this.$router.resolve({
          name: "PayAuthorityDetail",
          params: {
            Pid: item.OrderID,
            title: `Ủy quyền thanh toán (#${item.OrderID})`
          },
          query: {
            'noti_type': item.NotiType
          }
        });
      } else if (item.OrderType == 7) {
        routeData = this.$router.resolve({
          name: "InternalFinanceDetail",
          params: {
            Pid: item.OrderID,
            title: `Chi tiết thu chi (#${item.OrderID})`
          }
        });
      } else if (item.OrderType == 8) {
        routeData = this.$router.resolve({
          name: "OpportunityKaban",
          params: {
            title: `Cơ hội`
          },
          query: {
            'OpportunityID': item.OrderID
          }
        });
      } else if (item.OrderType == 9) {
        routeData = this.$router.resolve({
          name: "CheckBigpackageDetail",
          params: {
            Pid: item.OrderID,
            title: `Chi tiết đối soát bao hàng (#${item.OrderID})`
          }
        });
      } else if (item.OrderType == 10) {
        routeData = this.$router.resolve({
          name: "ContactDetail",
          params: {
            Pid: item.OrderID,
            title: `Chi tiết liên hệ (#${item.OrderID})`
          }
        });
      }
      if(routeData) {
        window.open(routeData.href, "_blank");
      }
    },
    senderRole(senderId, senderName) {
      const staff = _.find(this.staffs, { 'ID': senderId, 'Username': senderName });
      return staff ? staff.RoleType : null;
    },
    senderName(senderId, senderName) {
      const staff = _.find(this.staffs, { 'ID': senderId });
      return staff ? staff.FullName : senderName;
    },
    readAll(item) {
      this.$store.dispatch("notification/setDetail", {data: {'Status': 2, 'NotiType': item.NotiType}, id: item.ID});
    },
    displayAll(noti_type = 0) {
      let routeData = this.$router.resolve({
        name: "NotificationList",
        query: {
          'type': noti_type
        }
      });
      window.open(routeData.href, "_blank");
    }
  },
};
</script>
